import { supabase } from './supabase';

export interface FuelLogEntry {
  id: string;
  user_id: string;
  liter: number;
  price: number;
  date: string; // ISO date string
  created_at?: string;
}

// Fetch all fuel log entries for the current user, optionally filtered by month/year
export async function fetchFuelLogs() {
  const { data, error } = await supabase
    .from('fuel_log')
    .select('*')
    .order('date', { ascending: false });
  if (error) throw error;
  return data as FuelLogEntry[];
}

// Add a new fuel log entry
export async function addFuelLog(entry: Omit<FuelLogEntry, 'id' | 'created_at'>) {
  const { data, error } = await supabase
    .from('fuel_log')
    .insert([entry])
    .select()
    .single();
  if (error) throw error;
  return data as FuelLogEntry;
}

// Update an existing fuel log entry
export async function updateFuelLog(id: string, entry: Partial<Omit<FuelLogEntry, 'id' | 'user_id' | 'created_at'>>) {
  const { data, error } = await supabase
    .from('fuel_log')
    .update(entry)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data as FuelLogEntry;
}

// Delete a fuel log entry
export async function deleteFuelLog(id: string) {
  const { error } = await supabase
    .from('fuel_log')
    .delete()
    .eq('id', id);
  if (error) throw error;
  return true;
} 